import { getCookie } from "~utils";

const DEFAULT_OPTIONS = {
  forceLogin: false,
  locale: "zh_CN",
  analytics: false,
  onLogin: (user) => {},
  onSDKLogin: (user) => {},
  onLogout: () => {},
  env: null,
  disableSSO: false,
};

export default class SSOLogin {
  constructor(props = {}) {
    this.userInfo = null;
    this.props = { ...DEFAULT_OPTIONS, ...props };
  }

  handleLogin(customizedRedirectionUrl) {
    if (!this.userInfo) {
      if (window.matchMedia("(min-width: 1024px)").matches) {
        window.alpsLoginSDKInstance?.show();
      } else {
        let ssoSDKData = {};
        if (window.AlpsNavigationSDKData) {
          ssoSDKData = window.AlpsNavigationSDKData.header.meta.ssoSDK;
        } else {
          ssoSDKData = this.props.pageData.header.meta.ssoSDK;
        }
        const redirectUrl = encodeURIComponent(
          customizedRedirectionUrl || window.location.href
        );
        window.location.href =
          ssoSDKData.mobile[this.props.env] +
          "?redirect_url=" +
          redirectUrl +
          "&from_page=official";
      }
    }
  }

  handleLogout() {
    function getRootDomain(domain) {
      return `${domain.split(".").slice(-2).join(".")}`;
    }

    document.cookie = `alps-account-info=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=.${getRootDomain(
      window.location.hostname
    )}`;
    document.cookie = `onvo-s-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    this.userInfo = null;
    this.props.onLogout();
    this.checkUserInfo();
  }

  handleExternalLogin(customizedRedirectionUrl) {
    if (this.props.disableSSO) return; //under determine
    if (this.userInfo) {
      this.props.onLogin(this.userInfo);
    } else {
      this.handleLogin(customizedRedirectionUrl);
    }
  }

  checkUserInfo() {
    if (this.props.disableSSO) return;
    const currentUserInfo = getCookie("alps-account-info");
    if (currentUserInfo) {
      this.userInfo = JSON.parse(currentUserInfo);
      this.props.onLogin && this.props.onLogin(currentUserInfo);
    } else if (this.props.forceLogin) {
      this.handleLogin();
    }
  }

  getProps() {
    return this.props;
  }

  getUserInfo() {
    return this.userInfo;
  }
}
